import React from 'react'
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Table, Message, Menu, Icon, Dimmer, Loader, Dropdown } from 'semantic-ui-react';
import { getAllOutpatientClaimBySysAdmin } from '../../../actions'

class OutpatientList extends React.Component {

    DEFAULT_SEARCH_MAX = 10;
    DEFAULT_SEARCH_PAGE = 1;

    componentDidMount() {
        if (this.props.user.accessToken) {
            // Get claim data
            this.search();
        }
    }

    search() {
        // Get url query string
        let urlSearch = new URLSearchParams(this.props.history.location.search);

        let params = {};

        // Get page from url query string
        let searchPage = parseInt(urlSearch.get("searchPage"));
        if (searchPage) {
            params.searchPage = searchPage;
        } else {
            params.searchPage = this.DEFAULT_SEARCH_PAGE;
        }

        // Get search max from url query string
        let searchMax = parseInt(urlSearch.get("searchMax"));
        if (searchMax) {
            params.searchMax = searchMax;
        } else {
            params.searchMax = this.DEFAULT_SEARCH_MAX;
        }

        // Get filter companyId from url query string
        let filterCompanyId = urlSearch.get("companyId");
        if (filterCompanyId) params.companyId = filterCompanyId;

        // Get filter claimStatus from url query string
        let filterClaimStatus = urlSearch.get("claimStatus");
        if (filterClaimStatus){
            params.claimStatus = filterClaimStatus
        }else{
            params.claimStatus = "PROCESSING";
        }

        // Get filter name from url query string
        let filterName = urlSearch.get("name");
        if (filterName) params.name = "" + filterName.trim();

        // Get filter nric from url query string
        let filterNric = urlSearch.get("nric");
        if (filterNric) params.nric = "" + filterNric.trim().toLowerCase();

        // Call API
        this.props.getAllOutpatientClaimBySysAdmin(this.props.user.accessToken, params);
    }

    goToPage(page) {

        // Validation
        page = parseInt(page);
        if (!page) page = this.DEFAULT_SEARCH_MAX;

        // Set url and query string
        let urlSearch = new URLSearchParams(this.props.location.search);
        urlSearch.set("searchPage", page);

        // Go to url
        this.props.history.push({
            pathname: this.props.history.location.pathname,
            search: urlSearch.toString()
        });

    }

    onChangeSearchMax(searchMax) {

        // Validation
        searchMax = parseInt(searchMax);
        if (!searchMax) searchMax = this.DEFAULT_SEARCH_MAX;

        // Set url and query string
        let urlSearch = new URLSearchParams(this.props.location.search);
        urlSearch.set("searchMax", searchMax);
        urlSearch.set("searchPage", this.DEFAULT_SEARCH_PAGE);

        // Go to url
        this.props.history.push({
            pathname: this.props.history.location.pathname,
            search: urlSearch.toString()
        });
    }

    getPaginationInfo() {

        if (!Array.isArray(this.props.claims.allOutpatientData) || !this.props.claims.allOutpatientPagination || this.props.claims.allOutpatientData.length === 0) return "No Data";
        let urlSearch = new URLSearchParams(this.props.location.search);
        let page = parseInt(urlSearch.get("searchPage")) || this.DEFAULT_SEARCH_PAGE;
        let searchMax = parseInt(urlSearch.get("searchMax")) || this.DEFAULT_SEARCH_MAX;
        return `${(page - 1) * searchMax + 1} - ${(page - 1) * searchMax + this.props.claims.allOutpatientData.length} of ${this.props.claims.allOutpatientPagination.totalData}`;
    }

    render() {

        const loading = this.props.claims.allOutpatientLoading;
        const allOutpatientData = this.props.claims.allOutpatientData || [];
        const pagination = this.props.claims.allOutpatientPagination || {};

        return (
            <Dimmer.Dimmable>
                <Dimmer active={loading} inverted>
                    <Loader />
                </Dimmer>
                {!loading &&
                    <Table celled selectable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Transaction No</Table.HeaderCell>
                                <Table.HeaderCell>NRIC</Table.HeaderCell>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                                <Table.HeaderCell>Company Name</Table.HeaderCell>
                                <Table.HeaderCell>Visit Date</Table.HeaderCell>
                                <Table.HeaderCell>Provider</Table.HeaderCell>
                                <Table.HeaderCell>Status</Table.HeaderCell>
                                <Table.HeaderCell>Retry</Table.HeaderCell>
                                <Table.HeaderCell>View</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {
                                allOutpatientData.length === 0 ?
                                    <Table.Row>
                                        <Table.Cell colSpan={8} textAlign="center">
                                            <Message info> No data found. </Message>
                                        </Table.Cell>
                                    </Table.Row>
                                    :
                                    allOutpatientData.map((outpatient, key) => {

                                        const _id = outpatient._id;
                                        const transactionNo = outpatient.transactionNo;
                                        const claimantId = outpatient.claimantId;
                                        const username = outpatient.detailUser ? outpatient.detailUser.name : "";
                                        const companyName = outpatient.detailCompany ? outpatient.detailCompany.name : "";
                                        const visitDate = outpatient.visitDate;
                                        const providerName = outpatient.providerName;
                                        const claimStatus = outpatient.claimStatus;
                                        const claimRetry = outpatient.claimRetry;

                                        return (
                                            <Table.Row key={key}>
                                                <Table.Cell>{transactionNo}</Table.Cell>
                                                <Table.Cell> <Link to={`/systemadmin/user/update?nric=${claimantId}`}>{claimantId}</Link></Table.Cell>
                                                <Table.Cell>{username}</Table.Cell>
                                                <Table.Cell>{companyName}</Table.Cell>
                                                <Table.Cell>{visitDate}</Table.Cell>
                                                <Table.Cell>{providerName}</Table.Cell>
                                                <Table.Cell>{claimStatus}</Table.Cell>
                                                <Table.Cell textAlign="center">{claimRetry}</Table.Cell>
                                                <Table.Cell> <Link to={`/systemadmin/useroutpatient/view?_id=${_id}`}>View</Link> </Table.Cell>
                                            </Table.Row>
                                        );
                                    })
                            }
                        </Table.Body>
                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan='12'>
                                    <Menu floated='right' pagination={true}>
                                        <Menu.Item as='a' icon onClick={() => { this.goToPage(parseInt(pagination.searchPage) - 1) }}
                                            disabled={pagination.searchPage <= 1}>
                                            <Icon name='chevron left' />
                                        </Menu.Item>
                                        <Menu.Item>{this.getPaginationInfo()}</Menu.Item>
                                        <Menu.Item as='a' icon onClick={() => { this.goToPage(parseInt(pagination.searchPage) + 1) }}
                                            disabled={pagination.searchPage >= pagination.totalPage}>
                                            <Icon name='chevron right' />
                                        </Menu.Item>
                                    </Menu>
                                    <Menu floated='right' pagination={true}>
                                        <Menu.Item>Page</Menu.Item>
                                        <Dropdown scrolling item text={pagination.searchPage} defaultValue={this.DEFAULT_SEARCH_PAGE}>
                                            <Dropdown.Menu>
                                                {[...Array(pagination.totalPage)].map((e, i) =>
                                                    <Dropdown.Item key={i} onClick={() => this.goToPage(i + 1)}>{i + 1}</Dropdown.Item>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Menu>
                                    <Menu floated='right' pagination={true}>
                                        <Menu.Item>View</Menu.Item>
                                        <Dropdown item text={pagination.searchMax} defaultValue={this.DEFAULT_SEARCH_MAX}>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => this.onChangeSearchMax(this.DEFAULT_SEARCH_MAX)}>{this.DEFAULT_SEARCH_MAX}</Dropdown.Item>
                                                <Dropdown.Item onClick={() => this.onChangeSearchMax(20)}>20</Dropdown.Item>
                                                <Dropdown.Item onClick={() => this.onChangeSearchMax(50)}>50</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Menu>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>

                }
            </Dimmer.Dimmable>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        claims: state.systemAdminClaims
    };
}

export default connect(mapStateToProps, {
    getAllOutpatientClaimBySysAdmin,
})(withRouter(OutpatientList))